import LabelGroup from './label-group'

export type { LabelGroupProps } from './label-group'
export default LabelGroup
